import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_s6_subjects from './uganda_s6_subjects';
import TopNavbar from '../../components/TopNavbar';
import Uganda_classes from './uganda_classes';
import International_countries from '../international_countries';

const Uganda_s6 = ( ) => {
 
  return (
    <>
   <TopNavbar />
   <Uganda />
   <International_countries />
  <Uganda_s6_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_s6;
